import { ContainerDesktop } from "components/Container";
import { Divider } from "components/Divider/Divider";
import { Logo } from "components/Logo";
import React, { ReactNode, useEffect, useState } from "react";

import FooterJSON from "data/locales/id/footer.json";
import Link from "next/link";
import { Route } from "nextjs-routes";
import { IconSocial } from "components/Icon/IconSocial";
import { useSystemStore } from "components/PageHeader/systemStore";

export type Props = {
  children?: ReactNode;
  className?: string;
  wrapperClassName?: string;
  isFullHeight?: boolean;
  useNavbar?: boolean;
  isLoader?: boolean;
  useLoader?: boolean;
};

const SocialMedia = [
  {
    href: "https://www.instagram.com/gokampusofficial/?hl=en",
    icon: "instagram",
  },
  {
    href: "https://www.linkedin.com/company/gokampus/mycompany/",
    icon: "linkedin-square",
  },
];

const GKStore = [
  {
    href: "https://play.google.com/store/apps/details?id=com.and.gokampus&hl=en",
    icon: "/images/icon-google-play.png",
  },
  {
    href: "https://apps.apple.com/id/app/gokampus/id1456702223?l=id",
    icon: "/images/icon-app-store.png",
  },
];

const Footer: React.FC<Props> = ({}) => {
  const [products, setProducts] = useState(null);
  const [aboutUs, setAboutUs] = useState(null);

  useEffect(() => {
    setProducts(FooterJSON["Product"]);
    setAboutUs(FooterJSON["AboutUs"]);
  }, []);
  const theme = useSystemStore((state) => state.theme);

  return (
    <footer>
      <ContainerDesktop
        classBackgroundFull="bg-light_neutral10_to_dark_neutral50 !h-[308px] h-full md:flex items-center justify-center hidden"
        className="flex"
      >
        <div className="flex flex-col text-purple-60 m-auto">
          <div className="grid grid-cols-4 gap-32">
            <div className="flex flex-col gap-12">
              <div>
                <Logo useWhite={theme == "dark"} />
              </div>
              <div className="font-light">
                Belajar online GRATIS Sertifikat resmi dari institusi terpercaya
                untuk generasi muda Indonesia, #LearnBetterGoFaster with
                goKampus!
              </div>
            </div>
            <div className="flex flex-col gap-12 pl-[5rem]">
              <div className="font-bold">Produk</div>

              {products &&
                products.length &&
                products.map(
                  (product: {
                    id: number;
                    href: Route;
                    label: string;
                    icon: string | null;
                  }) => (
                    //@ts-ignore
                    <a
                      href={product.href ? product.href : "#"}
                      target="__blank"
                      rel="noopener noreferrer"
                    >
                      <div className="font-light">{product.label}</div>
                    </a>
                  )
                )}
            </div>
            <div className="flex flex-col gap-12 pl-[1rem]">
              <div className="font-bold">Tentang goKampus</div>

              {aboutUs &&
                aboutUs.length &&
                aboutUs.map(
                  (about: {
                    id: number;
                    href: Route;
                    label: string;
                    icon: string | null;
                  }) => (
                    //@ts-ignore
                    <Link href={about.href || "#"}>
                      <div className="font-light">{about.label}</div>
                    </Link>
                  )
                )}
            </div>
            <div className="flex flex-col gap-12">
              <div className="font-bold">Download Aplikasi goKampus</div>

              <div className="grid grid-cols-2 gap-12">
                {GKStore.map((store, i) => (
                  <a href={store.href} target="_blank">
                    <img
                      src={store.icon}
                      alt={"Store-" + i}
                      className="w-full"
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <Divider className="my-24 border-purple-30" />
          <div className="flex justify-between items-center">
            <div className="font-light text-b1">
              © 2025 PT. Sistem Sarjana Sejahtera.
            </div>
            <div className="flex gap-12">
              {SocialMedia.map((socmed) => (
                <a href={socmed.href} target="_blank">
                  {/* @ts-ignore */}
                  <IconSocial icon={socmed.icon} theme="rounded-full" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </ContainerDesktop>
    </footer>
  );
};

export default Footer;
